import { useEffect } from 'react'
import { Footer } from '../components/atoms/footer'
import { NavBar } from '../components/atoms/header'
import { Contact } from '../sections/Contact'
import { Hero } from '../sections/Hero'
import { Projects } from '../sections/Projects'
import { Services } from '../sections/Services'
import { Testimonials } from '../sections/Testimonials'
import { Welcome } from '../sections/Welcome'

export const Home = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return (
        <div>
            <NavBar />
            <Hero />
            <Welcome />
            <Services />
            <Projects />
            <Testimonials />
            <Contact />
            <Footer />
        </div>
    )
}
